import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIMS_INSERT } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import { convertYearInputToPayload } from '../../../../functions/convert';
import {
  appendConfirmSimilarImage,
  appendUploadFile,
  confirmSimilarImage,
  postWithImageCheck,
  SAVE_WARNING_KEY,
  showSaveWarnings,
} from '../../../../functions/imageUpload';

export const onUploadFile = ({ onSuccessCallBack }) => {
  const mutation = useMutation({
    mutationFn: async ({
      claimImage,
      receiptImage,
      warrantyId,
      customerCode,
      detail1,
      detail2,
      breakdownId,
      addressLine1,
      addressLine2,
      subDistrictId,
      zipCode,
      other,
      isCreateNewAddress,
      storeId,
      channelClaimId,
      bookingDate,
      noDeductWarranty,
      confirmSimilarImage: isConfirmSimilarImage,
    }) => {
      const formData = new FormData();
      appendUploadFile(formData, 'claimImage', claimImage);
      appendUploadFile(formData, 'receiptImage', receiptImage);
      appendConfirmSimilarImage(formData, isConfirmSimilarImage);
      formData.append('warrantyId', warrantyId);
      formData.append('customerCode', customerCode);
      formData.append('detail1', detail1);
      formData.append('detail2', detail2);
      formData.append('breakdownId', breakdownId);
      formData.append('addressLine1', addressLine1);
      formData.append('addressLine2', addressLine2);
      formData.append('subDistrictId', subDistrictId);
      formData.append('zipCode', zipCode);
      formData.append('other', other);
      formData.append('isCreateNewAddress', isCreateNewAddress);
      formData.append('storeId', storeId);
      formData.append('channelClaimId', channelClaimId);
      formData.append('bookingDate', convertYearInputToPayload(bookingDate));
      formData.append('noDeductWarranty', noDeductWarranty === 'Y' ? 'true' : 'false');
      const response = await postWithImageCheck(() => POST(POST_CLAIMS_INSERT(), formData));
      if (onSuccessCallBack) onSuccessCallBack(response);
      return response;
    },
    onSuccess: (result) => {
      if (showSaveWarnings(result, [SAVE_WARNING_KEY.IMAGE_HASH], () => window.location.reload()))
        return;
      openAlert({ model: 'message', type: 'success', message: result.message });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    onError: (response, variables) => {
      const isHandled = confirmSimilarImage(response, () =>
        mutation.mutate({ ...variables, confirmSimilarImage: true }),
      );
      if (isHandled) return;
      openAlert({
        model: 'message',
        type: 'error',
        message: response?.message || 'เกิดข้อผิดพลาด',
      });
    },
  });
  return mutation;
};
